import { mobile, notDesktop, styled, Text, useTranslation } from '@obvio/app'
import { Grid } from '@obvio/ui'

import { CenteredSection } from '../CenteredSection'

import type { Dict } from '@obvio/utils'
import type { ReactElement } from 'react'

type Stat = Dict<{
  title: string
  description: string
}>

type StatProps = {
  stat: Stat
}

const StatValue = styled(Text)`
  font-size: 2.5rem;
  font-weight: 300;
  text-align: right;
`

const StateDescription = styled(Text)`
  font-size: 1rem;
  font-weight: 300;
`

function StatsItem({ stat }: StatProps) {
  const { locale } = useTranslation()

  return (
    <Grid templateColumns="6rem 1fr" gap="medium">
      <StatValue>{stat[locale].title}</StatValue>
      <StateDescription>{stat[locale].description}</StateDescription>
    </Grid>
  )
}

const Wrap = styled(Grid)`
  @media ${notDesktop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media ${mobile} {
    grid-template-columns: 1fr;
  }
`

const stats: Stat[] = [
  {
    pl: {
      title: '100',
      description: 'miejsc noclegowych',
    },
    en: {
      title: '100',
      description: 'accommodation places',
    },
  },
  {
    pl: {
      title: '42',
      description: 'pokoje i apartamenty o różnorodym standardzie',
    },
    en: {
      title: '42',
      description: 'rooms and apartments of various standards',
    },
  },
  {
    pl: {
      title: '6',
      description: 'gabinetów spa',
    },
    en: {
      title: '6',
      description: 'spa rooms',
    },
  },
  {
    pl: {
      title: '200+',
      description:
        'm2 przestrzeni konferencyjnych niezależnych i dodatkowe przestrzenie otwarte',
    },
    en: {
      title: '200+',
      description:
        'm2 of independent conference space and additional open spaces',
    },
  },
  {
    pl: {
      title: '1',
      description: 'sala restauracyjna główna z barem do 100 osób',
    },
    en: {
      title: '1',
      description: 'main restaurant hall with a bar for 100 people',
    },
  },
  {
    pl: {
      title: '1',
      description: 'sala restauracyjna kameralna do 30 osób',
    },
    en: {
      title: '1',
      description: 'intimate restaurant hall for 30 people',
    },
  },
  {
    pl: {
      title: '35+',
      description: 'różnych scenariuszy atrakcji',
    },
    en: {
      title: '35+',
      description: 'various attraction scenarios',
    },
  },
  {
    pl: {
      title: '5',
      description: 'HA własnej winnicy i 7 szczepów wina',
    },
    en: {
      title: '5',
      description: 'HA of own vineyard and 7 wine varieties',
    },
  },
]

export function Stats(): ReactElement {
  return (
    <CenteredSection>
      <Wrap templateColumns="repeat(4, minmax(0,1fr))" gap="large">
        {stats.map((stat, i) => (
          // eslint-disable-next-line react/no-array-index-key -- stats are static
          <StatsItem key={i} stat={stat} />
        ))}
      </Wrap>
    </CenteredSection>
  )
}
